import { Component, Input, OnChanges } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ui-message-custom',
  templateUrl: './ui-message-custom.component.html',
  styleUrls: ['./ui-message-custom.component.scss']
})
export class UiMessageCustomComponent implements OnChanges {
  @Input() icon: string;
  @Input() theme: 'default' | 'info' = 'default';

  public usedTheme: string;

  ngOnChanges() {
    this.usedTheme = this.theme ? `theme-${this.theme}` : 'theme-default';
  }
}
